import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cookie-toast-wrap"
}
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "cookie-toast" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "links" }
const _hoisted_8 = { class: "item action" }
const _hoisted_9 = { class: "item tech" }
const _hoisted_10 = { class: "item custom" }
const _hoisted_11 = { class: "list-item" }
const _hoisted_12 = { class: "item" }
const _hoisted_13 = {
  class: "info",
  "data-full": ""
}
const _hoisted_14 = { class: "type" }
const _hoisted_15 = { class: "confirm" }

import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'CookieToast',
  setup(__props) {

const store = useStore();
const localizer = Localizer;
const isLoading = ref(true);
const isCustomize = ref(false);
const isActivateStatistics = ref(false);
const isActivateProfiling = ref(false);
const customizeCookieValues = ref<string[]>(["tech"]);

const isCookieToastVisible = computed(() => store.getters["cookieToastStore/isCookieToastVisible"]);
const routes = (window as any).App.routes;

watch(isCookieToastVisible, async (newValue: boolean) => {
    isLoading.value = true;
    store.commit("cookieToastStore/setCookieToastVisible", newValue);
    isLoading.value = false;
});

if (!CookieHelper.isCookiePolicy()) {
    store.commit("cookieToastStore/setCookieToastVisible", true);
}
isLoading.value = false;

function setCustomize() {
    isCustomize.value = !isCustomize.value;
}

function setStatistics() {
    isActivateStatistics.value = !isActivateStatistics.value;
    if (isActivateStatistics.value) {
        customizeCookieValues.value.push("stat");
    } else {
        const index = customizeCookieValues.value.indexOf("stat");
        if (index !== -1) {
            customizeCookieValues.value.splice(index, 1);
        }
    }
}

function setProfiling() {
    isActivateProfiling.value = !isActivateProfiling.value;
    if (isActivateProfiling.value) {
        customizeCookieValues.value.push("profile");
    } else {
        const index = customizeCookieValues.value.indexOf("profile");
        if (index !== -1) {
            customizeCookieValues.value.splice(index, 1);
        }
    }
}

function setCookieToast() {
    CookieHelper.setCookiePolicyAll();
    store.commit("cookieToastStore/setCookieToastVisible", false);
    window.location.reload();
}

function setOnlyTech() {
    CookieHelper.removeCookiePolicyAll();
    store.commit("cookieToastStore/setCookieToastVisible", false);
    window.location.reload();
}

function setCustomCookie() {
    CookieHelper.setCookie("ckp", customizeCookieValues.value.join("|"), 365);
    store.commit("cookieToastStore/setCookieToastVisible", false);
    window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (isCookieToastVisible.value && !isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setOnlyTech())),
              class: "close"
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("img", {
                src: "/images/close-dark.svg",
                width: "18",
                height: "18",
                class: "image",
                alt: "Valsped"
              }, null, -1)
            ]))]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[6] || (_cache[6] = _createElementVNode("img", {
                  src: "/images/cookie.svg",
                  class: "icon",
                  alt: "Cookie"
                }, null, -1)),
                _createTextVNode(_toDisplayString(_unref(localizer).get("CookieToast.Common.CookiePolicy")), 1)
              ]),
              _createElementVNode("span", {
                innerHTML: _unref(localizer).get('CookieToast.Common.Description', _unref(routes).DataSecurity_CookiePolicy, _unref(localizer).get('CookieToast.Common.CookiePolicy'))
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (setCookieToast())),
                  class: "button",
                  "data-border": ""
                }, _toDisplayString(_unref(localizer).get("CookieToast.Common.AgreeAll")), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (setOnlyTech())),
                  class: "button",
                  "data-border": ""
                }, _toDisplayString(_unref(localizer).get("CookieToast.Common.OnlyTechnicians")), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (setCustomize())),
                  class: "button",
                  "data-border": ""
                }, _toDisplayString(_unref(localizer).get("CookieToast.Common.Customize")), 1)
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(['customize', !isCustomize.value ? 'hden' : ''])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(localizer).get("CookieToast.Common.Technicians")), 1),
                    _cache[7] || (_cache[7] = _createTextVNode(" ValspedGroup.it, Google Analytics ", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (setCustomCookie())),
                  class: "button",
                  "data-border": ""
                }, _toDisplayString(_unref(localizer).get("CookieToast.Common.SavePreferences")), 1)
              ])
            ], 2)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})